import axios from 'axios';
//import { authService } from './authService';

const API_URL = process.env.VUE_APP_API_URL;

//axios.defaults.baseURL = API_URL;
//--------------------------------------------
// const eventSource = new EventSource(API_URL + "sse/notifications");

// eventSource.onmessage = (event) => {
//     console.log("SSE Powiadomienie:", event.data);
//     const data = JSON.parse(event.data);
//     alert(data.message);
// };

// eventSource.onopen = () => {
//     console.log('Połączono z SSE');
//     //reconnectDelay = 1000;  // Resetuj opóźnienie po udanym połączeniu
// };

// eventSource.onerror = (error) => {
//     console.error("Błąd SSE:", error);
// };
//--------------------------------------------

// Ustawienie tokena w nagłówkach
// function authHeader() {
//     const token = authService.getAuthToken();
//     if (token) {
//         return { Authorization: `Bearer ${token}` };
//     } else {
//         return {};
//     }
// }

export const shopService = {

    //--------------------------------------------------------------------------------
    getShops() {
        console.log("shopService.getShops() -> " + API_URL + "shop/getAll");
        return axios.get(API_URL + "shop/getAll");
    },

    getCurrentShop() {
        console.log("shopService.getCurrentShop() -> " + API_URL + "shop/GetCurrentShop");
        return axios.get(API_URL + "shop/GetCurrentShop");
    },

    setCurrentShop(shopId) {
        console.log("shopService.setCurrentShop() -> " + API_URL + "shop/setCurrentShop");
        return axios.put(API_URL + "shop/setCurrentShop", { ShopId: shopId });
    },

    getBuilders() {
        console.log("shopService.getBuilders() -> " + API_URL + "shop/getbuidlers");
        return axios.get(API_URL + "shop/getbuidlers");
    },

    setBuilderForCategory(shopId, categoryId, builderName) {
        console.log("shopService.setbuilderforcategory() -> " + API_URL + "shop/setbuilderforcategory", shopId, categoryId, builderName);
        return axios.post(API_URL + "shop/setbuilderforcategory", { ShopId: shopId, CategoryId: categoryId, BuilderName: builderName });
    }


};
